import { apiPost } from '../utils/request';
import { startRegistration } from '@simplewebauthn/browser';

export const verifySecurityKey = async (credential, name) => {
  return apiPost('/users/me/securityKeys', { credential, name });
};

export const registerSecurityKey = async (name) => {
  const { credentialOptions } = await apiPost('/users/me/securityKeys');

  credentialOptions.rp.id = window.location.hostname;
  console.log('credentialOptions ', credentialOptions);
  const credential = await startRegistration(credentialOptions);
  const key = await verifySecurityKey(credential, name);
  console.log('key ', key);
};

export const userShouldConfigTwoFa = (user) => {
  return (
    user.twoFactorAuthRequired &&
    !user.twoFactorAuthEnabled &&
    user.twoFactorAuthGracePeriod
  );
};
